import React, { useState, useEffect } from 'react';
import useStyles from './styles';
import { useTheme } from '@mui/material/styles';

import { Strings } from '../../utils/strings';
import Textbox from '../../components/Textbox';
import { Stack } from '@mui/material';
import FormSwitch from '../../components/Switch';
import NewField from '../../components/NewField';
import JobFormTools from '../../pages/Jobs/JobForms/NewJobForm/ToolsModal';
import { icons } from '../../utils/icons';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Dropdown from '../Dropdown';

const optionArray = [Strings.ISSUES_FOUND, Strings.NO_ISSUES_FOUND, Strings.NA];
const colorListArray = [
  { title: 'Red', value: '#ED4242' },
  { title: 'Green', value: '#34A885' },
  { title: 'Yellow', value: '#FBBC04' },
  { title: 'Gray', value: '#979797' },
];

export default function AdditionalFormField(props) {
  const classes = useStyles();
  const theme = useTheme();

  const {
    // additionalFields,
    removeField,
    addSubNewField,
    removeSubField,
    addNewGroupField,
    removeGroupFields,
    addSubNewGroupField,
    removeSubNewGroupField,
    fieldTextInputChange,
    fieldSubValueTextInputChange,
    groupFieldSubTextInputChange,
    groupFieldSubValueTextInputChange,
    onChangeFieldSwitch,
    onChangeFieldSwitchVisible,
    onChangeGroupFieldSwitch,
    onChangeGroupFieldSwitchVisible,
    groupUploadFieldValueTextInputChange,
    uploadFieldValueTextInputChange,
    setAdditionalFields,
    groupDropDownFieldChange,
    groupFieldSubValueDropDownFieldChange,
  } = props;
  const [Required, setRequired] = useState(false);
  const [showToolBox, setShowToolBox] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState('');
  const [openGroupRows, setOpenGroupRows] = useState([]);
  const [additionalData, setAdditionalData] = useState([]);

  useEffect(() => {
    if (props.additionalFields) {
      setAdditionalData(props.additionalFields);
    }
  }, [props.additionalFields]);

  const addNewGroupFields = (fieldType) => {
    addNewGroupField(fieldType);
    setShowToolBox(false);
  };

  const onOpenGroupRow = (rowIndex) => {
    if (openGroupRows.findIndex((item, index) => item === rowIndex) === -1) {
      setOpenGroupRows([...openGroupRows, rowIndex]);
    } else {
      setOpenGroupRows(openGroupRows.filter((item) => item !== rowIndex));
    }
  };

  const textInputField = (field, index, groupIndex, isDragging) => {
    return (
      <div
        className={
          groupIndex !== undefined
            ? classes.form_group_field
            : classes.form_group
        }
        style={{
          padding:
            groupIndex !== undefined && isDragging && '6px 10px 12px 10px',
        }}
      >
        <div className={classes.group_form_field_container}>
          <label className={classes.group_label}>{Strings.TEXT_INPUT}</label>
          <Stack
            direction='row'
            alignItems='center'
            justifyContent='space-between'
          >
            <FormSwitch
              label={Strings.VISIBLE_TO_CLIENT}
              value={field.visible}
              containerClassName={classes.form_input_switch_container}
              textClassName={classes.form_switch_label}
              onChange={() =>
                groupIndex !== undefined
                  ? onChangeGroupFieldSwitchVisible(index, groupIndex)
                  : onChangeFieldSwitchVisible(index)
              }
            />
            <FormSwitch
              label={Strings.REQUIRED}
              value={field.required}
              containerClassName={classes.form_input_switch_container}
              textClassName={classes.form_switch_label}
              onChange={() =>
                groupIndex !== undefined
                  ? onChangeGroupFieldSwitch(index, groupIndex)
                  : onChangeFieldSwitch(index)
              }
            />
            <img
              className={classes.action_icons}
              src={icons(theme).deleteIcon}
              alt=''
              onClick={() =>
                groupIndex !== undefined
                  ? removeGroupFields(index, groupIndex)
                  : removeField(index)
              }
            />
          </Stack>
        </div>
        <Textbox
          onChange={(e) =>
            groupIndex !== undefined
              ? groupFieldSubTextInputChange(e.target.value, groupIndex, index)
              : fieldTextInputChange(e.target.value, index)
          }
          value={field.title}
          placeholder='Title'
          labelClassName={classes.form_label}
          className={classes.group_form_input}
          containerClassName={classes.form_input_container}
        />
      </div>
    );
  };

  const dropdownField = (field, index, groupIndex, isDragging) => {
    return (
      <div
        className={
          groupIndex !== undefined
            ? classes.form_group_field
            : classes.form_group
        }
        style={{
          padding:
            groupIndex !== undefined && isDragging && '6px 10px 12px 10px',
        }}
      >
        <div className={classes.group_form_field_container}>
          <label className={classes.group_label}>{Strings.DROPDOWN}</label>
          <Stack
            direction='row'
            alignItems='center'
            justifyContent='space-between'
          >
            <FormSwitch
              label={Strings.VISIBLE_TO_CLIENT}
              value={field.visible}
              containerClassName={classes.form_input_switch_container}
              textClassName={classes.form_switch_label}
              onChange={() =>
                groupIndex !== undefined
                  ? onChangeGroupFieldSwitchVisible(index, groupIndex)
                  : onChangeFieldSwitchVisible(index)
              }
            />
            <FormSwitch
              label={Strings.REQUIRED}
              value={field.required}
              containerClassName={classes.form_input_switch_container}
              textClassName={classes.form_switch_label}
              onChange={() =>
                groupIndex !== undefined
                  ? onChangeGroupFieldSwitch(index, groupIndex)
                  : onChangeFieldSwitch(index)
              }
            />
            <img
              className={classes.action_icons}
              src={icons(theme).deleteIcon}
              alt=''
              onClick={() =>
                groupIndex !== undefined
                  ? removeGroupFields(index, groupIndex)
                  : removeField(index)
              }
            />
          </Stack>
        </div>
        <Textbox
          onChange={(e) =>
            groupIndex !== undefined
              ? groupFieldSubTextInputChange(e.target.value, groupIndex, index)
              : fieldTextInputChange(e.target.value, index)
          }
          value={field.title}
          placeholder='Title'
          labelClassName={classes.form_label}
          className={classes.group_form_input}
          containerClassName={classes.form_input_container}
        />
        <div>
          {field.options.length > 0 ? (
            <>
              {field.options.map((field, i) => (
                <Stack direction='row' alignItems='center' paddingTop={1}>
                  <img
                    className={classes.action_icons}
                    src={icons(theme).listIcon}
                    alt=''
                  />
                  <Textbox
                    onChange={(e) =>
                      groupIndex !== undefined
                        ? groupFieldSubValueTextInputChange(
                            e.target.value,
                            groupIndex,
                            index,
                            i
                          )
                        : fieldSubValueTextInputChange(e.target.value, index, i)
                    }
                    value={field.option}
                    placeholder='option'
                    // rightIcon={icons(theme).deleteIcon}
                    className={classes.form_input}
                    // rightIconClassName={classes.right_icon}
                    containerClassName={classes.form_field_input_container}
                    // onRightIcon={() =>
                    //   groupIndex !== undefined
                    //     ? removeSubNewGroupField(index, groupIndex, i)
                    //     : removeSubField(i, index)
                    // }
                    disabled={optionArray.includes(field.option)}
                    maxlength={80}
                  />
                  <Dropdown
                    placeholder={Strings.SELECT_AN_OPTION}
                    // isFixedWidth
                    isColorSelect
                    name='formStatus'
                    value={field.color}
                    containerClassName={classes.dropdown}
                    optionArray={colorListArray}
                    onChange={(e) =>
                      groupIndex !== undefined
                        ? groupFieldSubValueDropDownFieldChange(
                            e.target.value,
                            groupIndex,
                            index,
                            i
                          )
                        : groupDropDownFieldChange(e.target.value, index, i)
                    }
                  />
                  <img
                    className={classes.action_icons}
                    src={icons(theme).deleteIcon}
                    alt=''
                    onClick={() =>
                      groupIndex !== undefined
                        ? removeSubNewGroupField(index, groupIndex, i)
                        : removeSubField(i, index)
                    }
                  />
                </Stack>
              ))}
            </>
          ) : null}
        </div>
        <div className={classes.add_option_contain}>
          <label
            className={classes.add_option_label}
            onClick={() =>
              groupIndex !== undefined
                ? addSubNewGroupField(index, groupIndex)
                : addSubNewField(index)
            }
          >
            {Strings.Add_OPTION}
          </label>
        </div>
      </div>
    );
  };

  const radioField = (field, index, groupIndex, isDragging) => {
    return (
      <div
        className={
          groupIndex !== undefined
            ? classes.form_group_field
            : classes.form_group
        }
        style={{
          padding:
            groupIndex !== undefined && isDragging && '6px 10px 12px 10px',
        }}
      >
        <div className={classes.group_form_field_container}>
          <label className={classes.group_label}>{Strings.RADIO}</label>
          <Stack
            direction='row'
            alignItems='center'
            justifyContent='space-between'
          >
            <FormSwitch
              label={Strings.VISIBLE_TO_CLIENT}
              value={field.visible}
              textClassName={classes.form_switch_label}
              containerClassName={classes.form_input_switch_container}
              onChange={() =>
                groupIndex !== undefined
                  ? onChangeGroupFieldSwitchVisible(index, groupIndex)
                  : onChangeFieldSwitchVisible(index)
              }
            />
            <FormSwitch
              label={Strings.REQUIRED}
              value={field.required}
              textClassName={classes.form_switch_label}
              containerClassName={classes.form_input_switch_container}
              onChange={() =>
                groupIndex !== undefined
                  ? onChangeGroupFieldSwitch(index, groupIndex)
                  : onChangeFieldSwitch(index)
              }
            />
            <img
              className={classes.action_icons}
              src={icons(theme).deleteIcon}
              alt=''
              onClick={() =>
                groupIndex !== undefined
                  ? removeGroupFields(index, groupIndex)
                  : removeField(index)
              }
            />
          </Stack>
        </div>
        <Textbox
          onChange={(e) =>
            groupIndex !== undefined
              ? groupFieldSubTextInputChange(e.target.value, groupIndex, index)
              : fieldTextInputChange(e.target.value, index)
          }
          value={field.title}
          placeholder='Title'
          labelClassName={classes.form_label}
          className={classes.group_form_input}
          containerClassName={classes.form_input_container}
        />
        <div>
          {field.options.length > 0 ? (
            <>
              {field.options.map((field, i) => (
                <Stack direction='row' alignItems='center' paddingTop={1}>
                  <img
                    className={classes.action_icons}
                    src={icons(theme).listIcon}
                    alt=''
                  />
                  <Textbox
                    onChange={(e) =>
                      groupIndex !== undefined
                        ? groupFieldSubValueTextInputChange(
                            e.target.value,
                            groupIndex,
                            index,
                            i
                          )
                        : fieldSubValueTextInputChange(e.target.value, index, i)
                    }
                    value={field.option}
                    placeholder='option'
                    className={classes.form_input}
                    // rightIcon={icons(theme).deleteIcon}
                    // rightIconClassName={classes.right_icon}
                    containerClassName={classes.form_field_input_container}
                    // onRightIcon={() =>
                    //   groupIndex !== undefined
                    //     ? removeSubNewGroupField(index, groupIndex, i)
                    //     : removeSubField(i, index)
                    // }
                    disabled={optionArray.includes(field.option)}
                    maxlength={80}
                  />
                  <Dropdown
                    placeholder={Strings.SELECT_AN_OPTION}
                    // isFixedWidth
                    isColorSelect
                    name='formStatus'
                    value={field.color}
                    containerClassName={classes.dropdown}
                    optionArray={colorListArray}
                    onChange={(e) =>
                      groupIndex !== undefined
                        ? groupFieldSubValueDropDownFieldChange(
                            e.target.value,
                            groupIndex,
                            index,
                            i
                          )
                        : groupDropDownFieldChange(e.target.value, index, i)
                    }
                  />
                  <img
                    className={classes.action_icons}
                    src={icons(theme).deleteIcon}
                    alt=''
                    onClick={() =>
                      groupIndex !== undefined
                        ? removeSubNewGroupField(index, groupIndex, i)
                        : removeSubField(i, index)
                    }
                  />
                </Stack>
              ))}
            </>
          ) : null}
        </div>
        <div className={classes.add_option_contain}>
          <label
            className={classes.add_option_label}
            onClick={() =>
              groupIndex !== undefined
                ? addSubNewGroupField(index, groupIndex)
                : addSubNewField(index)
            }
          >
            {Strings.Add_OPTION}
          </label>
        </div>
      </div>
    );
  };

  const uploadFileField = (field, index, groupIndex, isDragging) => {
    const optionArray = ['fileSize', 'fileType', 'allowedFiles'];
    return (
      <div
        className={
          groupIndex !== undefined
            ? classes.form_group_field
            : classes.form_group
        }
        style={{
          padding:
            groupIndex !== undefined && isDragging && '6px 10px 12px 10px',
        }}
      >
        <div className={classes.group_form_field_container}>
          <label className={classes.group_label}>{Strings.UPLOAD_FILE}</label>
          <Stack
            direction='row'
            alignItems='center'
            justifyContent='space-between'
          >
            <FormSwitch
              label={Strings.VISIBLE_TO_CLIENT}
              value={field.visible}
              textClassName={classes.form_switch_label}
              containerClassName={classes.form_input_switch_container}
              onChange={() =>
                groupIndex !== undefined
                  ? onChangeGroupFieldSwitchVisible(index, groupIndex)
                  : onChangeFieldSwitchVisible(index)
              }
            />
            <FormSwitch
              label={Strings.REQUIRED}
              value={field.required}
              textClassName={classes.form_switch_label}
              containerClassName={classes.form_input_switch_container}
              onChange={() =>
                groupIndex !== undefined
                  ? onChangeGroupFieldSwitch(index, groupIndex)
                  : onChangeFieldSwitch(index)
              }
            />
            <img
              className={classes.action_icons}
              src={icons(theme).deleteIcon}
              alt=''
              onClick={() =>
                groupIndex !== undefined
                  ? removeGroupFields(index, groupIndex)
                  : removeField(index)
              }
            />
          </Stack>
        </div>
        <Textbox
          onChange={(e) =>
            groupIndex !== undefined
              ? groupFieldSubTextInputChange(e.target.value, groupIndex, index)
              : fieldTextInputChange(e.target.value, index)
          }
          value={field.title}
          placeholder={Strings.SELECTED_DROPDOWN}
          labelClassName={classes.form_label}
          className={classes.group_form_input}
          containerClassName={classes.form_input_container}
        />
        <div>
          {/* {field.options.length > 0 ? ( */}
          {/* <> */}
          {optionArray.map((opt, i) => (
            <Stack direction='row' alignItems='center' paddingTop={1}>
              <img
                className={classes.action_icons}
                src={icons(theme).listIcon}
                alt=''
              />
              <Textbox
                onChange={(e) =>
                  groupIndex !== undefined
                    ? groupUploadFieldValueTextInputChange(
                        e.target.value,
                        groupIndex,
                        index,
                        opt
                      )
                    : uploadFieldValueTextInputChange(
                        e.target.value,
                        index,
                        opt
                      )
                }
                type={opt === 'allowedFiles' ? 'number' : 'text'}
                value={field[opt]}
                placeholder={
                  opt === 'fileSize'
                    ? Strings.FILE_SIZE
                    : opt === 'fileType'
                    ? Strings.FILE_TYPE
                    : Strings.NUMBER_OF_FILE
                }
                className={classes.form_input}
                // rightIcon={
                //  icons(theme).deleteIcon
                // }
                // rightIconClassName={classes.right_icon}
                containerClassName={classes.form_field_input_container}
              />
            </Stack>
          ))}
          {/* </> */}
          {/* // ) : null} */}
        </div>
      </div>
    );
  };

  const checklistField = (field, index, groupIndex, isDragging) => {
    return (
      <div
        className={
          groupIndex !== undefined
            ? classes.form_group_field
            : classes.form_group
        }
        style={{
          padding:
            groupIndex !== undefined && isDragging && '6px 10px 12px 10px',
        }}
      >
        <div className={classes.group_form_field_container}>
          <label className={classes.group_label}>{Strings.CHECKLIST}</label>
          <Stack
            direction='row'
            alignItems='center'
            justifyContent='space-between'
          >
            <FormSwitch
              label={Strings.VISIBLE_TO_CLIENT}
              value={field.visible}
              textClassName={classes.form_switch_label}
              containerClassName={classes.form_input_switch_container}
              onChange={() =>
                groupIndex !== undefined
                  ? onChangeGroupFieldSwitchVisible(index, groupIndex)
                  : onChangeFieldSwitchVisible(index)
              }
            />
            <FormSwitch
              label={Strings.REQUIRED}
              value={field.required}
              textClassName={classes.form_switch_label}
              containerClassName={classes.form_input_switch_container}
              onChange={() =>
                groupIndex !== undefined
                  ? onChangeGroupFieldSwitch(index, groupIndex)
                  : onChangeFieldSwitch(index)
              }
            />
            <img
              className={classes.action_icons}
              src={icons(theme).deleteIcon}
              alt=''
              onClick={() =>
                groupIndex !== undefined
                  ? removeGroupFields(index, groupIndex)
                  : removeField(index)
              }
            />
          </Stack>
        </div>
        <Textbox
          onChange={(e) =>
            groupIndex !== undefined
              ? groupFieldSubTextInputChange(e.target.value, groupIndex, index)
              : fieldTextInputChange(e.target.value, index)
          }
          value={field.title}
          placeholder='Title'
          labelClassName={classes.form_label}
          className={classes.group_form_input}
          containerClassName={classes.form_input_container}
        />
        <div>
          {field.options.length > 0 ? (
            <>
              {field.options.map((field, i) => (
                <Stack direction='row' alignItems='center' paddingTop={1}>
                  <img
                    className={classes.action_icons}
                    src={icons(theme).listIcon}
                    alt=''
                  />
                  <Textbox
                    onChange={(e) =>
                      groupIndex !== undefined
                        ? groupFieldSubValueTextInputChange(
                            e.target.value,
                            groupIndex,
                            index,
                            i
                          )
                        : fieldSubValueTextInputChange(e.target.value, index, i)
                    }
                    value={field.option}
                    placeholder='option'
                    // rightIcon={icons(theme).deleteIcon}
                    className={classes.form_input}
                    // rightIconClassName={classes.right_icon}
                    containerClassName={classes.form_field_input_container}
                    // onClick={() =>
                    //   groupIndex !== undefined
                    //     ? removeSubNewGroupField(index, groupIndex, i)
                    //     : removeSubField(i, index)
                    // }
                    disabled={optionArray.includes(field.option)}
                    maxlength={80}
                  />
                  <Dropdown
                    placeholder={Strings.SELECT_AN_OPTION}
                    // isFixedWidth
                    isColorSelect
                    name='formStatus'
                    value={field.color}
                    containerClassName={classes.dropdown}
                    optionArray={colorListArray}
                    onChange={(e) =>
                      groupIndex !== undefined
                        ? groupFieldSubValueDropDownFieldChange(
                            e.target.value,
                            groupIndex,
                            index,
                            i
                          )
                        : groupDropDownFieldChange(e.target.value, index, i)
                    }
                  />
                  <img
                    className={classes.action_icons}
                    src={icons(theme).deleteIcon}
                    alt=''
                    onClick={() =>
                      groupIndex !== undefined
                        ? removeSubNewGroupField(index, groupIndex, i)
                        : removeSubField(i, index)
                    }
                  />
                </Stack>
              ))}
            </>
          ) : null}
        </div>
        <div className={classes.add_option_contain}>
          <label
            className={classes.add_option_label}
            onClick={() =>
              groupIndex !== undefined
                ? addSubNewGroupField(index, groupIndex)
                : addSubNewField(index)
            }
          >
            {Strings.Add_OPTION}
          </label>
        </div>
      </div>
    );
  };

  const groupField = (field, index) => {
    let showGroupFields =
      openGroupRows.findIndex((item) => item === index) !== -1;
    let groupFieldsList = field && field.groupElements;
    return (
      <div className={classes.form_group}>
        <div className={classes.group_form_field_container}>
          <Stack direction='row' alignItems='center'>
            <img
              className={classes.toggle_arrow}
              src={
                openGroupRows.findIndex((item) => item === index) !== -1
                  ? icons(theme).rightArrow
                  : icons(theme).downArrow
              }
              alt=''
              onClick={() => onOpenGroupRow(index)}
            />
            <label className={classes.group_label}>{Strings.GROUP}</label>
          </Stack>
          <Stack
            direction='row'
            alignItems='center'
            justifyContent='space-between'
          >
            <FormSwitch
              label={Strings.VISIBLE_TO_CLIENT}
              value={field.visible}
              textClassName={classes.form_switch_label}
              containerClassName={classes.form_input_switch_container}
              onChange={() => onChangeFieldSwitchVisible(index)}
            />

            <FormSwitch
              label={Strings.REQUIRED}
              value={field.required}
              textClassName={classes.form_switch_label}
              containerClassName={classes.form_input_switch_container}
              onChange={() => onChangeFieldSwitch(index)}
            />
            <img
              className={classes.action_icons}
              src={icons(theme).deleteIcon}
              alt=''
              onClick={() => removeField(index)}
            />
          </Stack>
        </div>
        {!showGroupFields && (
          <>
            <Textbox
              onChange={(e) => fieldTextInputChange(e.target.value, index)}
              value={field.title}
              placeholder='Title'
              labelClassName={classes.form_label}
              className={classes.group_form_input}
              containerClassName={classes.form_input_container}
            />
            {groupFieldsList && groupFieldsList.length > 0 ? (
              <>
                <DragDropContext onDragEnd={(e) => onDragEndGroup(e, index)}>
                  <Droppable droppableId='droppable'>
                    {(provided, snapshot) => (
                      <div
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        // style={getListStyle(snapshot.isDraggingOver)}
                      >
                        {groupFieldsList.map((item, i) => (
                          <Draggable
                            key={item._id || item.id}
                            draggableId={item._id || item.id}
                            index={i}
                          >
                            {(provided, snapshot) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                // style={getItemStyle(
                                //   snapshot.isDragging,
                                //   provided.draggableProps.style
                                // )}
                              >
                                {renderGroupFields(
                                  item,
                                  i,
                                  index,
                                  snapshot.isDragging
                                )}
                              </div>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </>
            ) : null}
            <NewField
              containerClassName={classes.form_input_container}
              onClick={() => {
                setShowToolBox(!showToolBox);
                setSelectedGroup(index);
              }}
            />
            {showToolBox && selectedGroup === index && (
              <JobFormTools
                onDropDownClick={() =>
                  addNewGroupFields({ elementType: 'Dropdown', index })
                }
                onTextInputClick={() =>
                  addNewGroupFields({ elementType: 'Text Input', index })
                }
                onRadioClick={() =>
                  addNewGroupFields({ elementType: 'Radio', index })
                }
                onUploadFileClick={() =>
                  addNewGroupFields({ elementType: 'Upload File', index })
                }
                onCheckListClick={() =>
                  addNewGroupFields({ elementType: 'Check List', index })
                }
                isFromGroupField={true}
              />
            )}
          </>
        )}
      </div>
    );
  };

  const renderGroupFields = (option, index, groupIndex, isDragging) => {
    return (
      <>
        {option.elementType === 'Dropdown' &&
          dropdownField(option, index, groupIndex, isDragging)}
        {option.elementType === 'Text Input' &&
          textInputField(option, index, groupIndex, isDragging)}
        {option.elementType === 'Radio' &&
          radioField(option, index, groupIndex, isDragging)}
        {option.elementType === 'Upload File' &&
          uploadFileField(option, index, groupIndex, isDragging)}
        {option.elementType === 'Check List' &&
          checklistField(option, index, groupIndex, isDragging)}
      </>
    );
  };
  const renderFields = (field, index) => {
    return (
      <>
        {field.elementType === 'Group' && groupField(field, index)}
        {field.elementType === 'Dropdown' && dropdownField(field, index)}
        {field.elementType === 'Text Input' && textInputField(field, index)}
        {field.elementType === 'Radio' && radioField(field, index)}
        {field.elementType === 'Upload File' && uploadFileField(field, index)}
        {field.elementType === 'Check List' && checklistField(field, index)}
      </>
    );
  };

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const grid = 8;

  // const getItemStyle = (isDragging, draggableStyle) => ({
  //   // some basic styles to make the items look a bit nicer
  //   userSelect: 'none',
  //   padding:  grid * 2,
  //   // margin: `0 0 ${grid}px 0`,

  //   // change background colour if dragging
  //   background: isDragging ? 'lightgreen' : 'grey',

  //   // styles we need to apply on draggables
  //   ...draggableStyle,
  // });

  // const getListStyle = (isDraggingOver) => ({
  //   background: isDraggingOver ? 'lightblue' : 'lightgrey',
  //   padding: grid,
  //   // width: 250,
  // });

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    const items = reorder(
      additionalData,
      result.source.index,
      result.destination.index
    );
    setAdditionalData(items);
    setAdditionalFields(items);
  };

  const onDragEndGroup = (result, index) => {
    if (!result.destination) {
      return;
    }
    let newData = additionalData.map((item, i) => {
      if (i === index) {
        const items = reorder(
          item.groupElements,
          result.source.index,
          result.destination.index
        );
        item = { ...item, groupElements: items };
      }
      return item;
    });
    setAdditionalData(newData);
    setAdditionalFields(newData);
  };
  return (
    <>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId='droppable'>
          {(provided, snapshot) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              // style={getListStyle(snapshot.isDraggingOver)}
            >
              {additionalData.map((item, index) => (
                <Draggable
                  key={item._id || item.id}
                  draggableId={item._id || item.id}
                  index={index}
                >
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      // style={getItemStyle(
                      //   snapshot.isDragging,
                      //   provided.draggableProps.style
                      // )}
                    >
                      {renderFields(item, index)}
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </>
  );
}
